import { createContext, ReactNode, useContext, useState } from 'react'

type FeedbackButtonState = 'inactive' | 'active' | undefined

const FeedbackButtonStateContext = createContext<ReturnType<typeof useState<FeedbackButtonState>>>(undefined!)

interface FeedbackButtonStateProviderProps {
  children: ReactNode
}

export default function FeedbackButtonStateProvider(props: FeedbackButtonStateProviderProps) {
  return (
    <FeedbackButtonStateContext.Provider value={useState<FeedbackButtonState>('inactive')}>
      {props.children}
    </FeedbackButtonStateContext.Provider>
  )
}

export function useFeedbackButtonState() {
  const context = useContext(FeedbackButtonStateContext)

  if (context === undefined) {
    throw new Error('useFeedbackButtonState must be used within a FeedbackButtonStateProvider')
  }

  return context
}
